import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CheckRender from "../../../components/Common/CheckRender";
import {
  formatFileExtension,
  formatFileSize,
  formatLastModified,
  renderFileNameWithTooltip,
} from "../utils/AnexosTableUtils";
import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";

const ColumnasDocumentos = ({ abrirModalDocumento, onEliminarAnexo, archivosEnviados, codigosCoberturasDuplicadas, coberturasEnviadasFlag = false, anexosPorCobertura = {} }) => [
  {
    title: "Nombre del Archivo",
    dataIndex: "name",
    key: "name",
    width: "35%",
    render: renderFileNameWithTooltip,
    ellipsis: true,
  },
  {
    title: "Código de Cobertura",
    dataIndex: "codigoCobertura",
    key: "codigoCobertura",
    width: "15%",
    render: (codigoCobertura) => codigoCobertura || "N/A",
  },
  {
    title: "Tipo",
    dataIndex: "type",
    key: "type",
    width: "10%",
    render: (_, record) => formatFileExtension(null, record?.name),
  },
  {
    title: "Tamaño",
    dataIndex: "size",
    key: "size",
    width: "10%",
    render: formatFileSize,
  },
  {
    title: "Fecha de Modificación",
    dataIndex: "lastModified",
    key: "lastModified",
    width: "12%",
    render: formatLastModified,
  },
  {
    title: "Acciones",
    key: "actions",
    width: "18%",
    render: (_, record) => {
      const estaEnviado = archivosEnviados?.has(record.id) || archivosEnviados?.has(record.name);
      const perteneceACoberturaDuplicada = codigosCoberturasDuplicadas?.has(record.codigoCobertura);
      const codigoCobertura = record.codigoCobertura || "";
      const cantidadAnexosCobertura = anexosPorCobertura[codigoCobertura] || 0;
      const tieneSoloUnAnexo = cantidadAnexosCobertura === 1;
      
      const buttonStylesBase = {
        background: "none",
        border: "none",
        fontSize: "16px",
        padding: "4px 8px",
      };

      const buttonStylesVer = {
        ...buttonStylesBase,
        cursor: "pointer",
        color: "#1890ff",
        opacity: 1,
      };

      const buttonStylesEliminar = {
        ...buttonStylesBase,
        cursor: "pointer",
        color: "#ff4d4f",
        opacity: 1,
      };

      const containerStyles = {
        display: "flex",
        gap: "8px",
        justifyContent: "center",
      };

      const puedeEliminar = !coberturasEnviadasFlag && 
        (!estaEnviado || perteneceACoberturaDuplicada) && 
        !tieneSoloUnAnexo;

      return (
        <div style={containerStyles}>
          <button
            onClick={() => abrirModalDocumento(record)}
            style={buttonStylesVer}
            title="Ver documento"
          >
            <EyeOutlined />
          </button>
          {puedeEliminar && (
            <button
              onClick={() => onEliminarAnexo(record.id)}
              style={buttonStylesEliminar}
              title="Eliminar anexo"
            >
              <DeleteOutlined />
            </button>
          )}
        </div>
      );
    },
  },
];

const RenderAnexos = ({ documentosAnexos, abrirModalDocumento, onEliminarAnexo, archivosEnviados, codigosCoberturasDuplicadas, coberturasEnviadasFlag = false }) => {
  const emptyStateStyles = {
    textAlign: "center",
    padding: "40px",
    color: "#666",
    fontSize: "16px",
  };

  const contarAnexosPorCobertura = (anexos) => {
    const conteo = {};
    anexos.forEach((anexo) => {
      const codigoCobertura = anexo.codigoCobertura || "";
      conteo[codigoCobertura] = (conteo[codigoCobertura] || 0) + 1;
    });
    return conteo;
  };

  const anexosPorCobertura = contarAnexosPorCobertura(documentosAnexos);

  return (
    <Section>
      <CheckRender allowed={documentosAnexos.length > 0}>
        <CustomTable
          columns={ColumnasDocumentos({ 
            abrirModalDocumento, 
            onEliminarAnexo, 
            archivosEnviados, 
            codigosCoberturasDuplicadas, 
            coberturasEnviadasFlag,
            anexosPorCobertura,
          })}
          dataSource={documentosAnexos}
          pageSize={100}
          containerWidth="100%"
          width="100%"
        />
      </CheckRender>
      <CheckRender allowed={documentosAnexos.length === 0}>
        <div style={emptyStateStyles}>
          No hay documentos adjuntos para este paciente
        </div>
      </CheckRender>
    </Section>
  );
};

export default RenderAnexos;

